<div class="policy-overview-card" (click)="goToCase(primaryPolicy)">
  <div class="policy-overview-card__policy-information">
    <div class="policy-overview-card__case">
      <div>
        <div class="policy-overview-card__primary-label">{{ caseType }} For</div>
        <div class="insured">
          {{ insuredFullName }}
        </div>
        <div class="policy-overview-card__application-progress" *ngIf="caseType === 'Quote'">
          <progress-indicator [currentProgress]="progressPercentage" [maxProgress]="1"></progress-indicator>
        </div>
      </div>
      <div class="policy-overview-card__arrow-icon">
        <img src="../../../../../common/img/icons/next-arrow.svg" />
      </div>
    </div>
    <div class="policy-overview-card__item">
      <div class="policy-overview-card__secondary-label">Coverage</div>
      <div class="policy-overview-card__value">
        {{ totalFaceAmount }}
      </div>
    </div>
    <div class="policy-overview-card__item">
      <div class="policy-overview-card__secondary-label">Policy Type</div>
      <div class="policy-overview-card__value">
        {{ primaryPolicyDescription }}
        <span *ngIf="secondaryPolicyDescription">&amp;</span>
      </div>
      <div class="policy-overview-card__value" *ngIf="secondaryPolicyDescription">
        {{ secondaryPolicyDescription }}
      </div>
    </div>
    <div class="policy-overview-card__item">
      <div class="policy-overview-card__secondary-label">Premium</div>
      <div class="policy-overview-card__value" *ngIf="shouldShowPremium">
        {{ premiumWithFrequency }}
      </div>
      <div class="policy-overview-card__value" *ngIf="!shouldShowPremium">Premium Pending Review</div>
    </div>
    <div class="next-arrow-svg">
      <img src="../../../../../common/img/icons/next-arrow.svg" />
    </div>
  </div>
  <div class="policy-overview-card__status" *ngIf="cardStatusTitles.length > 0">
    <cpds-badge
      *ngIf="needsPaymentAuthorization || hasPaymentFailed"
      class="policy-overview-card__badge"
      [intent]="'highlight'"
      >Action required</cpds-badge
    >
    <div class="policy-overview-card__status__container">
      <div class="policy-overview-card__status__icon">
        <img
          *ngIf="(caseType === 'Application' || caseType === 'Quote' || caseType === 'Conversion') && !isCancelled"
          src="../../../../../common/img/icons/pending.svg"
        />
        <img
          *ngIf="caseType === 'Policy' && !isCancelled && !needsPaymentAuthorization && !hasPaymentFailed"
          src="../../../../../common/img/icons/small_confirm.svg"
        />
        <cpds-icon
          *ngIf="!isCancelled && (needsPaymentAuthorization || hasPaymentFailed)"
          class="icon"
          icon="status-info"
        ></cpds-icon>
        <img *ngIf="isCancelled" src="../../../../../common/img/icons/cancel.svg" />
      </div>
      <div class="policy-overview-card__message">
        <div class="policy-overview-card__title">
          <ng-container *ngFor="let title of cardStatusTitles">{{ title }} &nbsp;</ng-container>
        </div>
        <div class="policy-overview-card__subtitle">
          <ng-container *ngFor="let subTitle of cardStatusSubTitles">
            {{ subTitle }}
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="caseType === 'Conversion'">
      <button
        class="button button--blue button--secondary policy-overview-card__button policy-overview-card__button--convertpolicypending"
      >
        Review Application
      </button>
    </div>
  </div>
</div>
